import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Fix mobile keyboard bounce: set --dvh CSS variable = real viewport height
function setDvh() {
  const vh = window.visualViewport ? window.visualViewport.height : window.innerHeight;
  document.documentElement.style.setProperty('--dvh', `${vh * 0.01}px`);
}
setDvh();
window.addEventListener('resize', setDvh);
if (window.visualViewport) {
  window.visualViewport.addEventListener('resize', setDvh);
}
window.addEventListener('orientationchange', () => setTimeout(setDvh, 200));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
